import travelAgency_0 from "../../images/projects/travelAgency/0.PNG";
import travelAgency_1 from "../../images/projects/travelAgency/1.PNG";
import travelAgency_2 from "../../images/projects/travelAgency/2.PNG";
import travelAgency_3 from "../../images/projects/travelAgency/3.PNG";
import travelAgency_4 from "../../images/projects/travelAgency/4.PNG";
import travelAgency_5 from "../../images/projects/travelAgency/5.PNG";
import travelAgency_6 from "../../images/projects/travelAgency/6.PNG";
import travelAgency_7 from "../../images/projects/travelAgency/7.PNG";
import travelAgency_8 from "../../images/projects/travelAgency/8.PNG";
import travelAgency_9 from "../../images/projects/travelAgency/9.PNG";
import travelAgency_10 from "../../images/projects/travelAgency/10.PNG";
import travelAgency_11 from "../../images/projects/travelAgency/11.PNG";
import travelAgency_12 from "../../images/projects/travelAgency/12.PNG";
import travelAgency_13 from "../../images/projects/travelAgency/13.PNG";
import travelAgency_14 from "../../images/projects/travelAgency/14.PNG";

export default function travelAgencyImages() {
  return [
    travelAgency_0,
    travelAgency_1,
    travelAgency_2,
    travelAgency_3,
    travelAgency_4,
    travelAgency_5,
    travelAgency_6,
    travelAgency_7,
    travelAgency_8,
    travelAgency_9,
    travelAgency_10,
    travelAgency_11,
    travelAgency_12,
    travelAgency_13,
    travelAgency_14,
  ];
}
